import { Badge, makeStyles, Text, tokens } from "@fluentui/react-components";
import { Fragment } from "react";
import {
  GateFlightInfo,
  GateTooltipRow,
} from "../../../../utils/maps/GateConstants";
import GateTooltipCell from "./GateTooltipCell";

export type GateToolTipProps = {
  gateName: string;
  displayStatusLabel: string;
  displayStatusColor: string;

  current: GateFlightInfo;
  next: GateFlightInfo;
};

const gateTooltipRows: GateTooltipRow[] = [
  {
    label: "Arrival Flight",
    field: "arrivalFlight",
    statusField: "arrivalTimeStatus",
    showStatus: true,
  },
  {
    label: "Departure Flight",
    field: "departureFlight",
    statusField: "departureTimeStatus",
    showStatus: true,
  },
  { label: "Arrival Time", field: "arrivalTime" },
  { label: "Departure Time", field: "departureTime" },
  { label: "Allocation Start", field: "allocationStartTime" },
  { label: "Allocation End", field: "allocationEndTime" },
  { label: "Aircraft Type", field: "aircraftType" },
];

const GateToolTip: React.FC<GateToolTipProps> = ({
  gateName,
  displayStatusLabel,
  displayStatusColor,
  current,
  next,
}) => {
  const styles = useStyles();

  return (
    <article className={styles.card} data-testid="gateToolTip">
      <header className={styles.header}>
        <Text weight="bold" size={400}>
          {gateName}
        </Text>
        <Badge
          className={styles.badge}
          shape="rounded"
          style={{ backgroundColor: displayStatusColor }}
        >
          {displayStatusLabel}
        </Badge>
      </header>

      <section className={styles.grid}>
        <div />
        <span className={styles.columnTitle}>Current</span>
        <span className={styles.columnTitle}>Next</span>

        {gateTooltipRows.map((row) => (
          <Fragment key={row.label}>
            <span>{row.label}</span>
            <GateTooltipCell flightInfo={current} row={row} />
            <GateTooltipCell flightInfo={next} row={row} />
          </Fragment>
        ))}
      </section>
    </article>
  );
};

export default GateToolTip;

const useStyles = makeStyles({
  card: {
    width: "max-content",
    minWidth: "280px",
    padding: "4px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  badge: {
    marginRight: "10px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "max-content repeat(2, minmax(72px, auto))",
    rowGap: tokens.spacingVerticalM,
    columnGap: tokens.spacingVerticalL,
    marginTop: "10px",
    alignItems: "center",
    fontSize: "12px",
  },
  columnTitle: {
    fontWeight: 600,
    fontSize: "16px",
  },
});
